module.exports = __webpack_public_path__ + "img/indu_3.35c97220.png";